import axios from "axios";
import idAuthHeader from "../auth-header";

const API_URL = process.env.REACT_APP_API_URL + "api/completedtranscript/";

class JobService {
  async getJobsForAccount(accountId) {
    return axios.get(API_URL + "jobs", {
      params: { accountId: accountId },
      headers: await idAuthHeader(),
    });
  }
  async updateJob(markCoTranscriptsModel) {
    return axios.patch(API_URL + "approve", markCoTranscriptsModel, {
      headers: await idAuthHeader(),
    });
  }
  async getMrrDocuments(accountId) {
    return axios.get(API_URL + "mrr-documents", {
      params: { accountId: accountId },
      headers: await idAuthHeader(),
    });
  }
}

const jobService = new JobService();
export default jobService;
